import BackOfficeHeader from "components/commons/BackofficeHeader";
import React from "react";

const Header = () => {
  return <BackOfficeHeader title={"Bandeja de trámites"} />;
};

export default Header;
